import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=4580c4b8&scoped=true&"
import script from "./userInfo.vue?vue&type=script&lang=js&"
export * from "./userInfo.vue?vue&type=script&lang=js&"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=4580c4b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4580c4b8",
  null
  
)

export default component.exports